import React from "react";
import styled from "styled-components";
import { Tooltip } from "antd";

import { SvgRoyalAir, SvgPartnerAircraft } from "@/assets/icons";
import { RATypography } from "@/components/customs";

export function AircraftOwnershipTagTooltip({ isOwner = false, isPartner = false }) {
	return (
		<Container>
			{isOwner && (
				<Tooltip
					color="#fff"
					placement="bottom"
					title={
						<RATypography color="#595959" variant="sub-heading5">
							Aircraft operated by Royal Air are available depending on service area and aircraft
							scheduling.
						</RATypography>
					}
					overlayInnerStyle={{
						padding: 16,
						borderRadius: 8,
					}}
				>
					<RoyalAirTag>
						<SvgRoyalAir /> Royal Air
					</RoyalAirTag>
				</Tooltip>
			)}
			{isPartner && (
				<Tooltip
					color="#fff"
					placement="bottom"
					title={
						<RATypography color="#595959" variant="sub-heading5">
							Aircraft from our vetted partner network are available through Royal Air to ensure quality
							and reliability.
						</RATypography>
					}
					overlayInnerStyle={{
						padding: 16,
						borderRadius: 8,
					}}
				>
					<PartnerTag>
						<SvgPartnerAircraft /> Partner
					</PartnerTag>
				</Tooltip>
			)}
		</Container>
	);
}

export function AircraftOwnershipTag({ isPartner = false }) {
	return (
		<Container>
			{isPartner ? (
				<PartnerTag>
					<SvgPartnerAircraft /> Partner
				</PartnerTag>
			) : (
				<RoyalAirTag>
					<SvgRoyalAir /> Royal Air
				</RoyalAirTag>
			)}
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
`;

const RoyalAirTag = styled.div`
	display: inline-flex;
	height: 24px;
	padding: 3px 10px;
	align-items: center;
	color: #fff;
	font-family: "DM Sans";
	font-size: 10px;
	font-weight: 500;
	gap: 4px;
	border-radius: 24px;
	background: linear-gradient(90deg, #ffb11a 0%, #d8644a 100%);
`;

const PartnerTag = styled.div`
	display: inline-flex;
	height: 24px;
	padding: 3px 10px;
	align-items: center;
	color: #fff;
	font-family: "DM Sans";
	font-size: 10px;
	font-weight: 500;
	gap: 4px;
	border-radius: 24px;
	background: linear-gradient(90deg, #79b968 0%, #00a8a8 100%);
`;
